//Landing page when a developer is logged in

const DevDashboard = () => {
    return (
        <>
            <div className="home">
                <h3>Dev Dashboard</h3>
                <p>The developer dashboard is coming soon. In the mean time, create a hiring manager account to see the hiring manager dashboard</p>
            </div>

        </>

    )
}

export default DevDashboard